import styled from 'styled-components';

export const ShareButtonWrapper = styled.span<{ $fillColor: string }>`
    cursor: pointer;
    display: inline-block;
    width: 30px;
    height: 30px;
    color: ${props => props.$fillColor};
`;
